import React from 'react';
import Translate from 'react-translate-component';
import { notification } from 'antd';

import { APPROVAL_NOTIFICATION, PUSH_NOTIFICATION } from 'constants/notificationTypes';
import Notification from 'components/common/notifications/Notification';
import PushNotification from 'components/common/notifications/PushNotification';
import { pushTitleTranslatePath } from 'constants/notificationTypes';

export const pushApprovalNotification = (notes) => {
    const key = APPROVAL_NOTIFICATION;
    const closeNotification = () => notification.close(key);

    notification.close(key);
    notification.open({
        key,
        className: 'approval-notification',
        message: <Translate content='notify.title' />,
        description: <Notification notes={notes} closeNotification={closeNotification} />,
        duration: 0
    });
}

export const pushServerNotification = data => {
    const key = PUSH_NOTIFICATION;
    const titlePath = pushTitleTranslatePath[data.notificationType] || 'notify.title';

    const closeNotification = () => notification.close(key);
    notification.open({
        key,
        className: 'push-notification',
        message: <Translate content={titlePath} />,
        description: <PushNotification data={data} closeNotification={closeNotification} />,
        duration: 0,
    });
};
